// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnInit } from '@angular/core';
import {D3eService} from '../../../services/d3e-service';
import {HeaderService} from '../../header.service';
import {TranslateService} from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {AuthService} from '../../../services/auth-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { IDownloadVersion } from '../../dialogs/news/news.component';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-d3e-version-history',
    templateUrl: './d3e-version-history.component.html',
    styleUrls: ['./d3e-version-history.component.scss'],
    standalone: false
})
export class D3eVersionHistoryComponent implements OnInit {
  style = {
    'width': '1050px',
    'margin': '100px auto'
  }
  versions: {
      major: number;
      minor: number;
      revision: number;
      path: string;
      sha256sum?: string;
      system?: string;
      feature_flags?: string;
      activation_code?: string;
      partner_id?: number | null;
      sub_uuid?: string | null;
      installer_name?: string;
      subscription_path?: string;
      description?: string;
      detail: SafeHtml;
      created_timestamp?: string;
      rest_api_version?: { major: number; minor: number; revision: number; date?: string };
      msi_url?: string | null;
      msi_version?: string | null;
      pba_versions?: IDownloadVersion[] | null;
      win_fde_versions?: IDownloadVersion[] | null;
      ubuntu_fde_versions?: IDownloadVersion[] | null;
      rhel_fde_versions?: IDownloadVersion[] | null;
      win_cli_versions?: IDownloadVersion[] | null;
      ubuntu_cli_versions?: IDownloadVersion[] | null;
      rhel_cli_versions?: IDownloadVersion[] | null;
      win_agent_versions?: IDownloadVersion[] | null;
      ubuntu_agent_versions?: IDownloadVersion[] | null;
      rhel_agent_versions?: IDownloadVersion[] | null;
      cli_guide_url?: string | null;
      cli_guide_version?: string | null
  }[] = [];
  term = '';
  isLoggedIn$ = this.authService.isLoggedIn$;

  fSearch: string;
  fRelease: string;
  fNone: string;
  fNotes: string;

  title: string;
  constructor(
      private d3eService: D3eService,
      private headerService: HeaderService,
      private translate: TranslateService,
      private readonly authService: AuthService,
      private sanitizer: DomSanitizer
  ) {
    this.translate.get(['DVH_SEARCH', 'DVH_RELEASE', 'DVH_NONE', 'DVH_NOTES', 'TITLE_VERSION']).subscribe(vals => {
      this.fSearch = vals['DVH_SEARCH'];
      this.fRelease = vals['DVH_RELEASE'];
      this.fNone = vals['DVH_NONE'];
      this.fNotes = vals['DVH_NOTES'];

      this.title = vals['TITLE_VERSION'];
    });
  }

  ngOnInit(): void {
    this.headerService.setTitle(this.title);
    this.getVersions();
  }

  getVersions() {
    this.versions = null;
    this.d3eService.get_d3e_version_history(this.term)
        .pipe(untilDestroyed(this))
        .subscribe(response => {
            this.versions = response.versions
                .filter(el => el.description)
                .map(version => ({
                  ...version,
                  detail: this.sanitizeHtml(version.detail)
            }));
        },
        () => { this.versions = []; });
  }

  sanitizeHtml(html: string): SafeHtml {
    const clean = DOMPurify.sanitize(html);
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }

}
